module.exports = __webpack_public_path__ + "9c9a9be9ac280d43f1515c0b5783f385.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/notifications/system.png
// module id = 651
// module chunks = 0